import React, { useState } from "react";


const WingsModal = ({
  fetchWingsData,
  wingserrorMessage,
  wingsLoading,
  type,
}) => {
  const [wingsId, setWingsId] = useState("");


  // Regular expression for a valid WINGS ID (e.g., "VB/SR/25/ 1")
  const wingsIdRegex = /^[A-Z]{4}\/[A-Z]{1}\/\d{2}\/\s*\d+$/;
  const winRegex = /^M.*/;

  // Prevent closing modal when clicking outside
  const handleOutsideClick = (e) => {
    e.stopPropagation();
  };

  const handleFetchData = () => {
    if (
      type === "STM"
        ? winRegex.test(wingsId.trim())
        : wingsIdRegex.test(wingsId.trim())
    ) {
      fetchWingsData(wingsId); // Call the parent function to fetch data
    } else {
      console.log("Invalid Reciept No.");
    }
  };



  // Check if the WINGS ID is valid
  const isWingsIdValid =
    type === "STM"
      ? winRegex.test(wingsId.trim())
      : wingsIdRegex.test(wingsId.trim());

  console.log("isWingsvalid", isWingsIdValid);

  return (
    <>
      <div className="absolute h-full inset-0 bg-black bg-opacity-50 backdrop-blur-sm  transition-opacity duration-300 ease-in-out z-10">
        <div
          className="bg-white rounded-2xl top-40 m-auto shadow-lg p-8 relative w-full max-w-md"
          onClick={handleOutsideClick}
          style={{ animation: "fadeIn 0.3s ease-out" }}
        >
          <h2 className="text-2xl center font-semibold text-gray-800 mb-6">
            {type === "STM" ? "VIN No." : "Receipt No."}
          </h2>
          <div>
            <label
              htmlFor="wingsId"
              className="block text-sm font-medium text-gray-600 mb-2"
            >
              {type === "STM" ? "Enter VIN No." : "Enter Receipt No."}
            </label>
            <input
              type="text"
              required
              id="wingsId"
              value={wingsId}
              onChange={(e) => setWingsId(e.target.value.toUpperCase())}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-shadow shadow-sm"
              placeholder={
                type === "STM"
                  ? "Enter VIN No. (e.g. MZBGB813LSN220797)"
                  : "Enter Receipt No. (e.g. RAVB/CD/12/ 3)"
              }
            />
            <button
              onClick={handleFetchData}
              className={`w-full mt-6 px-4 py-3 font-medium rounded-lg transition-colors focus:ring-2 focus:ring-blue-400 ${isWingsIdValid
                ? "bg-blue-600 text-white hover:bg-blue-700"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }`}
              disabled={!isWingsIdValid || wingsLoading} // Disable button if WINGS ID is invalid
            >
              {wingsLoading ? "Loading..." : "Fetch Data"}
            </button>
          </div>
          {/* Display the error message if booking data is not found */}
          {wingserrorMessage && (
            <p className="text-red-500 mt-4 text-center text-sm">
              {wingserrorMessage}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default WingsModal;
